import getPostLink from '@/functions/getPostLink'
import forEach from 'dcode/functions/forEach'

export default function getNotFound (basic) {
  return forEach(basic, item => {
    return {
      ...item,
      href: getPostLink(item, true),
      to: getPostLink(item)
    }
  })
}
